/** Scroll an element into view if it isn't already visible */
//  -> uses the standard `scrollIntoView()` with `block: 'nearest'`, which scrolls the minimum amount needed and does nothing when the element is already in view; this is not the non-standard `Element.scrollIntoViewIfNeeded()`
export default function scrollIntoViewIfNeeded(element: HTMLElement | null | undefined): void {
	element?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}
